export default "__VITE_ASSET__BHoYUAUF__"